import { Button, Table, Tooltip, Typography } from 'antd';
import { truncateStringEllipsis } from '../../../utils/functions';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { ColumnsType } from 'antd/lib/table';
import { getCategoriaPunto } from '../../../utils/categorias_punto.constant';
import { ReactComponent as Plus } from '../../../res/svg/plus-green.svg';
import { ReactComponent as Excel } from '../../../res/svg/excel.svg';
import { ReactComponent as Word } from '../../../res/svg/word.svg';
import { ReactComponent as Images } from '../../../res/svg/images.svg';
import Icon from '@ant-design/icons';
import { ReactComponent as Remove } from '../../../res/svg/remove-outlined.svg';
import { unselectPoint, getReportsExcel, getWordReport } from '../../../store/slice/reportsSlice';
import './ReportsTableContent.less';
import moment from 'moment';
import { getNumberOfPhotos } from '../../../utils/ApiGeometryUtils';
import { useMemo } from 'react';
import { GeometryService } from '../../../store/services/map/geometry.service';

const { Text } = Typography;

interface Props {
  onClose: () => any;
}

function ReportsTableContent({ onClose }: Props) {

  const dispatch = useAppDispatch();
  const points = useAppSelector(state => state.reports.points);
  const loadingWordReport = useAppSelector(state => state.reports.loadingWordReport);
  const loadingExcelReport = useAppSelector(state => state.reports.loadingExcelReport);

  const sorter: any = (a: any, b: any) =>
    isNaN(a) && isNaN(b) ? (a || '').localeCompare(b || '') : a - b;

  const columns: ColumnsType<any> = [
    Table.SELECTION_COLUMN,
    Table.EXPAND_COLUMN,
    {
      title: 'Titulo',
      dataIndex: 'titulo',
      render: (_id, row) => <Text>{truncateStringEllipsis(row.titulo, 32)}</Text>,
      width: 230,
    },
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
      render: (_id, row) => <Text>{truncateStringEllipsis(row.descripcion, 42)}</Text>,
    },
    {
      title: 'Categoría',
      dataIndex: 'categoria',
      render: (_id, row) => <Text>{getCategoriaPunto(row.categoria)}</Text>,
    },
    {
      title: 'N° de Acta',
      dataIndex: 'numeroActa',
      render: (_id, row) => <Text>{row.numeroActa ? row.numeroActa : '-'}</Text>,
    },
    {
      title: 'N° de Expediente',
      dataIndex: 'numExp',
      render: (_id, row) => <Text>{row.numExp ? row.numExp : '-'}</Text>,
    },
    {
      title: 'Fecha',
      dataIndex: 'createdAt',
      render: (_id, row) => <Text>{moment(row.createdAt).format('DD/MM/YYYY')}</Text>,
    },
    {
      title: 'Fotos',
      dataIndex: 'adjuntos',
      render: (_id, row) => (
        row.adjuntos?.length ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Images /> <span style={{ marginLeft: 4 }}>{row.adjuntos?.length}</span>
          </div>
        ) : <Text>-</Text>
      ),
      width: 80,
    },
    {
      title: '...',
      className: 'reports-table-content__actions-col',
      render: (_id, row) => (
        <div>
          <Button
            className={'reports-table-content__delete '}
            size='large'
            shape='round'
            onClick={() => {
              dispatch(unselectPoint(row));
            }}
            type={'ghost'}
            icon={<Icon component={Remove} />}
          />
        </div>
      ),
      width: 80,
    },
  ];

  const maxPhotosExceeded = useMemo(
    () => getNumberOfPhotos(points) > parseInt(process.env.REACT_APP_TASK_REPORTS_MAX_PHOTOS!),
    [points],
  );

  const downloadReport = (action: (points: number[]) => any, filename: string) => {
    const idPoints = points.map(value => value.id);
    dispatch(action(idPoints)).then((value: any)=>{
      const url = window.URL.createObjectURL(value.payload);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
  }

  const downloadReportExcel = () =>{
    downloadReport(getReportsExcel, `reporte_${Date.now()}.xlsx`)
  }

  const downloadReportWord = () =>{
    downloadReport(getWordReport, `informe_${Date.now()}.doc`)
  }

  return (
    <div className={'reports-table-content'}>
      <div className={'reports-table-content__table-container'}>
        <Text>Los siguientes puntos serán agregados al Documento:</Text>
        <Table
          className={'reports-table-content__table'}
          columns={columns}
          dataSource={points}
          rowKey={(g) => g.id}
          locale={{ emptyText: 'No hay puntos que mostrar.' }}
          pagination={false}
        />
      </div>

      <Button
        className={'reports-table-content__add-more'}
        type='ghost'
        shape='round'
        icon={<Plus />}
        onClick={() => onClose()}
        size={'large'}
      >
        Agregar más puntos
      </Button>
      <div className={'reports-table-content__buttons'}>
        <Button
          disabled={!points.length}
          style={{ marginRight: 24 }}
          className={'reports-table-content__generate-doc'}
          type='primary'
          shape='round'
          icon={<Excel />}
          loading={loadingExcelReport}
          onClick={downloadReportExcel}
          size={'large'}
        >
          Descargar Reporte (.xls)
        </Button>
        <Tooltip trigger={maxPhotosExceeded ? 'hover' : ''}
                 title={'Superaste la cantidad máxima de fotos posibles en un informe.'}>
          <Button
            disabled={!points.length || maxPhotosExceeded}
            className={'reports-table-content__generate-doc'}
            type='primary'
            shape='round'
            icon={<Word />}
            loading={loadingWordReport}
            onClick={downloadReportWord}
            size={'large'}
          >
            Descargar Informe (.doc)
          </Button>
        </Tooltip>
      </div>
    </div>


  );
}

export default ReportsTableContent;
